module.exports = __webpack_public_path__ + "img/AT0000002613865.ef290c83.png";